import { Injectable } from '@angular/core';

import { toFixed } from '../../../../core/services/utils/numbers';

@Injectable({
    providedIn: 'root'
})
export class PedidoItemImpostoCalculoService {

     /** Calcula o valor do ICMS do item do pedido */
     calcularValorIcms(valorTotal: number, percAliquotaIcms: number): number {
        valorTotal = valorTotal && !isNaN(valorTotal) ? Number(valorTotal) : 0;
        percAliquotaIcms = percAliquotaIcms && !isNaN(percAliquotaIcms) ? Number(percAliquotaIcms) : 0;

        const valorIcms = (valorTotal * percAliquotaIcms) / 100;
        return toFixed(valorIcms, 2);
    }

    /** Calcula o valor do IPI do item do pedido */
    calcularValorIpi(ipiIsento: boolean, valorTotal: number, percAliquotaIpi: number): number {
        // Se for isento de IPI, então retorna 0,00
        if (ipiIsento) {
            return 0;
        }

        valorTotal = valorTotal && !isNaN(valorTotal) ? Number(valorTotal) : 0;
        percAliquotaIpi = percAliquotaIpi && !isNaN(percAliquotaIpi) ? Number(percAliquotaIpi) : 0;

        const valorIpi = (valorTotal * percAliquotaIpi) / 100;
        return toFixed(valorIpi, 2);
    }
}
